var map = {
	"./AITextDetector": [
		15448,
		9,
		4586
	],
	"./AITextDetector.css": [
		19945,
		9,
		3700
	],
	"./AITextDetector.jsx": [
		15448,
		9,
		4586
	],
	"./ActivityScoreCard": [
		4376,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		5118,
		4268
	],
	"./ActivityScoreCard.jsx": [
		4376,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		5118,
		4268
	],
	"./Admin": [
		37558,
		9,
		4664,
		4382,
		5034,
		684
	],
	"./Admin.jsx": [
		37558,
		9,
		4664,
		4382,
		5034,
		684
	],
	"./AllProposals": [
		9987,
		9,
		2953
	],
	"./AllProposals.css": [
		96242,
		9,
		2515
	],
	"./AllProposals.jsx": [
		9987,
		9,
		2953
	],
	"./Annoucements": [
		68594,
		9,
		5107
	],
	"./Annoucements.jsx": [
		68594,
		9,
		5107
	],
	"./AnnoucementsFeeds": [
		26546,
		9,
		9330
	],
	"./AnnoucementsFeeds.jsx": [
		26546,
		9,
		9330
	],
	"./AppraisalDashboard": [
		17074,
		9,
		8930,
		2273,
		691,
		3651,
		4620,
		680
	],
	"./AppraisalDashboard.jsx": [
		17074,
		9,
		8930,
		2273,
		691,
		3651,
		4620,
		680
	],
	"./AppraisalHistory": [
		80467,
		9,
		8930,
		2273,
		4620,
		9372
	],
	"./AppraisalHistory.jsx": [
		80467,
		9,
		8930,
		2273,
		4620,
		9372
	],
	"./AsanaTasksModal": [
		62142,
		9,
		5766,
		8621,
		1238,
		3162
	],
	"./AsanaTasksModal.jsx": [
		62142,
		9,
		5766,
		8621,
		1238,
		3162
	],
	"./AttendanceCard": [
		91188,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		5118,
		5512
	],
	"./AttendanceCard.jsx": [
		91188,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		5118,
		5512
	],
	"./AttendanceReport": [
		62075,
		9,
		8930,
		2273,
		4664,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		8767,
		1542,
		5034,
		2997,
		5118,
		3704
	],
	"./AttendanceReport.jsx": [
		62075,
		9,
		8930,
		2273,
		4664,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		8767,
		1542,
		5034,
		2997,
		5118,
		3704
	],
	"./AttendanceReportsHR/AttendanceLog": [
		86582,
		9,
		4664,
		691,
		5766,
		5842,
		9223,
		3722,
		4399,
		9488,
		5034,
		2997,
		7926,
		4457,
		6935
	],
	"./AttendanceReportsHR/AttendanceLog.jsx": [
		86582,
		9,
		4664,
		691,
		5766,
		5842,
		9223,
		3722,
		4399,
		9488,
		5034,
		2997,
		7926,
		4457,
		6935
	],
	"./AttendanceReportsHR/ExtraHoursLogs": [
		13128,
		9,
		4664,
		5636,
		5034,
		2997,
		3260
	],
	"./AttendanceReportsHR/ExtraHoursLogs.jsx": [
		13128,
		9,
		4664,
		5636,
		5034,
		2997,
		3260
	],
	"./AttendanceReportsHR/MonthlySummary": [
		615,
		9,
		3927
	],
	"./AttendanceReportsHR/MonthlySummary.jsx": [
		615,
		9,
		3927
	],
	"./AttendanceReportsHR/OvertimeTable": [
		4855,
		9,
		2074,
		2313
	],
	"./AttendanceReportsHR/OvertimeTable.jsx": [
		4855,
		9,
		2074,
		2313
	],
	"./AttendanceReportsHR/TimeInRecords": [
		97912,
		9,
		4664,
		5034,
		2997,
		9958
	],
	"./AttendanceReportsHR/TimeInRecords.jsx": [
		97912,
		9,
		4664,
		5034,
		2997,
		9958
	],
	"./AttendanceReportsHR/modalsForAttendance/AttendanceImportModal": [
		87926,
		9,
		5766,
		3722,
		4399,
		7926,
		7426
	],
	"./AttendanceReportsHR/modalsForAttendance/AttendanceImportModal.jsx": [
		87926,
		9,
		5766,
		3722,
		4399,
		7926,
		7426
	],
	"./AttendanceReportsHR/modalsForAttendance/EmployeeAttendanceModal": [
		90747,
		9,
		5766,
		859
	],
	"./AttendanceReportsHR/modalsForAttendance/EmployeeAttendanceModal.jsx": [
		90747,
		9,
		5766,
		859
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV": [
		44457,
		9,
		5842,
		9223,
		4457,
		3115
	],
	"./AttendanceReportsHR/modalsForAttendance/ExportAllEmployeeAttendanceCSV.jsx": [
		44457,
		9,
		5842,
		9223,
		4457,
		3115
	],
	"./ChatBox": [
		80068,
		9,
		1542,
		1316
	],
	"./ChatBox.css": [
		2163,
		9,
		7530
	],
	"./ChatBox.jsx": [
		80068,
		9,
		1542,
		1316
	],
	"./CircularProgress": [
		3711,
		9,
		7337
	],
	"./CircularProgress.jsx": [
		3711,
		9,
		7337
	],
	"./ClientTaskLog": [
		46503,
		9,
		8767,
		5371,
		1113
	],
	"./ClientTaskLog.jsx": [
		46503,
		9,
		8767,
		5371,
		1113
	],
	"./ColorPicker": [
		81142,
		9,
		388,
		1278
	],
	"./ColorPicker.css": [
		25461,
		9,
		3424
	],
	"./ColorPicker.jsx": [
		81142,
		9,
		388,
		1278
	],
	"./ComplainOrSuggestion": [
		51651,
		9,
		1237
	],
	"./ComplainOrSuggestion.jsx": [
		51651,
		9,
		1237
	],
	"./Complaint": [
		91441,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		8197,
		2574
	],
	"./Complaint.jsx": [
		91441,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		8197,
		2574
	],
	"./ComplaintList": [
		79926,
		9,
		8002
	],
	"./ComplaintList.jsx": [
		79926,
		9,
		8002
	],
	"./Currency": [
		41800,
		9,
		4664,
		334,
		5034,
		2997,
		578
	],
	"./Currency.jsx": [
		41800,
		9,
		4664,
		334,
		5034,
		2997,
		578
	],
	"./Customer": [
		48247,
		9,
		4664,
		5766,
		3336,
		5034,
		2997,
		1115
	],
	"./Customer.jsx": [
		48247,
		9,
		4664,
		5766,
		3336,
		5034,
		2997,
		1115
	],
	"./Dashboard": [
		89238,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		6180,
		5118,
		2561
	],
	"./Dashboard.jsx": [
		89238,
		9,
		8930,
		2273,
		5766,
		2700,
		8621,
		9080,
		1238,
		23,
		6180,
		5118,
		2561
	],
	"./EditProposal": [
		94792,
		9,
		2700,
		9080,
		5577
	],
	"./EditProposal.jsx": [
		94792,
		9,
		2700,
		9080,
		5577
	],
	"./EmailFeature": [
		32140,
		9,
		1443,
		321
	],
	"./EmailFeature.jsx": [
		32140,
		9,
		1443,
		321
	],
	"./Employee": [
		33147,
		9,
		4664,
		1809,
		5034,
		2997,
		5539
	],
	"./Employee.jsx": [
		33147,
		9,
		4664,
		1809,
		5034,
		2997,
		5539
	],
	"./EmployeeBirthadyNot": [
		66049,
		9,
		3389
	],
	"./EmployeeBirthadyNot.jsx": [
		66049,
		9,
		3389
	],
	"./Employees/Dashboard": [
		7867,
		9,
		3722,
		1137,
		733,
		4746,
		4661
	],
	"./Employees/Dashboard.jsx": [
		7867,
		9,
		3722,
		1137,
		733,
		4746,
		4661
	],
	"./Employees/DocumentRequests": [
		36882,
		9,
		7834
	],
	"./Employees/DocumentRequests.jsx": [
		36882,
		9,
		7834
	],
	"./Employees/EmployeeEdit": [
		68779,
		9,
		8930,
		2273,
		9906,
		1065,
		8565,
		235
	],
	"./Employees/EmployeeEdit.jsx": [
		68779,
		9,
		8930,
		2273,
		9906,
		1065,
		8565,
		235
	],
	"./Employees/EmployeeExport": [
		81117,
		9,
		5842,
		9223,
		1117,
		433
	],
	"./Employees/EmployeeExport.jsx": [
		81117,
		9,
		5842,
		9223,
		1117,
		433
	],
	"./Employees/EmployeeForm": [
		46353,
		9,
		6957
	],
	"./Employees/EmployeeForm.jsx": [
		46353,
		9,
		6957
	],
	"./Employees/EmployeeShow": [
		79476,
		9,
		691,
		5842,
		9223,
		5886,
		1117,
		796
	],
	"./Employees/EmployeeShow.jsx": [
		79476,
		9,
		691,
		5842,
		9223,
		5886,
		1117,
		796
	],
	"./Employees/Employees": [
		93936,
		9,
		691,
		5842,
		9223,
		3722,
		1137,
		733,
		2618,
		1117,
		4746,
		5334,
		5966
	],
	"./Employees/Employees.jsx": [
		93936,
		9,
		691,
		5842,
		9223,
		3722,
		1137,
		733,
		2618,
		1117,
		4746,
		5334,
		5966
	],
	"./Employees/LeaveBalanceModal": [
		42913,
		9,
		691,
		7907
	],
	"./Employees/LeaveBalanceModal.jsx": [
		42913,
		9,
		691,
		7907
	],
	"./Employees/ProfileDetailsModal": [
		32953,
		9,
		691,
		5334,
		7691
	],
	"./Employees/ProfileDetailsModal.jsx": [
		32953,
		9,
		691,
		5334,
		7691
	],
	"./Employees/SectionApproval": [
		79079,
		9,
		6409
	],
	"./Employees/SectionApproval.jsx": [
		79079,
		9,
		6409
	],
	"./ExtraHours": [
		23374,
		9,
		2700,
		8621,
		3072
	],
	"./ExtraHours.jsx": [
		23374,
		9,
		2700,
		8621,
		3072
	],
	"./ExtraHoursApproval": [
		99983,
		9,
		6489
	],
	"./ExtraHoursApproval.jsx": [
		99983,
		9,
		6489
	],
	"./ExtraHoursModal": [
		30631,
		9,
		5179
	],
	"./ExtraHoursModal.jsx": [
		30631,
		9,
		5179
	],
	"./FloatingChatWindow": [
		59117,
		9,
		3143
	],
	"./FloatingChatWindow.jsx": [
		59117,
		9,
		3143
	],
	"./Gallery": [
		58071,
		9
	],
	"./Gallery.jsx": [
		58071,
		9
	],
	"./GenerateEnergySound": [
		83271,
		9
	],
	"./GenerateEnergySound.jsx": [
		83271,
		9
	],
	"./GoogleAuthSignInPage": [
		46773,
		9,
		6500,
		6471
	],
	"./GoogleAuthSignInPage.jsx": [
		46773,
		9,
		6500,
		6471
	],
	"./GoogleKeyWordsPlanner": [
		80204,
		9,
		6500,
		8098
	],
	"./GoogleKeyWordsPlanner.jsx": [
		80204,
		9,
		6500,
		8098
	],
	"./GoogleTrends": [
		50376,
		9,
		8767,
		7970
	],
	"./GoogleTrends.jsx": [
		50376,
		9,
		8767,
		7970
	],
	"./HireReq/HireReq": [
		43716,
		9,
		8930,
		2273,
		4830
	],
	"./HireReq/HireReq.jsx": [
		43716,
		9,
		8930,
		2273,
		4830
	],
	"./HireReq/HireReqForm": [
		93703,
		9,
		8930,
		2273,
		3124
	],
	"./HireReq/HireReqForm.jsx": [
		93703,
		9,
		8930,
		2273,
		3124
	],
	"./ImageCollage": [
		82319,
		9,
		5239,
		9861
	],
	"./ImageCollage.css": [
		54622,
		9,
		9079
	],
	"./ImageCollage.jsx": [
		82319,
		9,
		5239,
		9861
	],
	"./InterviewNotifications": [
		60310,
		9
	],
	"./InterviewNotifications.jsx": [
		60310,
		9
	],
	"./Invoice": [
		76826,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		8197,
		592
	],
	"./Invoice.jsx": [
		76826,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		8197,
		592
	],
	"./LeaveBenefitRequests": [
		33321,
		9,
		691,
		3240
	],
	"./LeaveBenefitRequests.jsx": [
		33321,
		9,
		691,
		3240
	],
	"./LeaveRequestList": [
		80756,
		9,
		691,
		2263
	],
	"./LeaveRequestList.jsx": [
		80756,
		9,
		691,
		2263
	],
	"./LeaveRequestList_backup": [
		59360,
		9,
		691,
		4592
	],
	"./LeaveRequestList_backup.jsx": [
		59360,
		9,
		691,
		4592
	],
	"./LeaveSummary": [
		78673,
		9,
		1137,
		733,
		2600
	],
	"./LeaveSummary.jsx": [
		78673,
		9,
		1137,
		733,
		2600
	],
	"./LeavesForm": [
		11355,
		9,
		7225
	],
	"./LeavesForm.jsx": [
		11355,
		9,
		7225
	],
	"./Login": [
		7790,
		9,
		8621,
		7094
	],
	"./Login.jsx": [
		7790,
		9,
		8621,
		7094
	],
	"./Logout": [
		30223,
		9,
		7089
	],
	"./Logout.jsx": [
		30223,
		9,
		7089
	],
	"./MaintenancePlan": [
		70400,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		7489,
		8233
	],
	"./MaintenancePlan.jsx": [
		70400,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		5034,
		7489,
		8233
	],
	"./MaintenancePlanNew": [
		72906,
		9,
		8930,
		2273,
		691,
		1809,
		7221,
		7489,
		3977
	],
	"./MaintenancePlanNew.jsx": [
		72906,
		9,
		8930,
		2273,
		691,
		1809,
		7221,
		7489,
		3977
	],
	"./MetaLengthChecker": [
		89525,
		9,
		3665
	],
	"./MetaLengthChecker.jsx": [
		89525,
		9,
		3665
	],
	"./MyProfile": [
		17688,
		9,
		8930,
		691,
		1809,
		8737,
		3041,
		2308
	],
	"./MyProfile.jsx": [
		17688,
		9,
		8930,
		691,
		1809,
		8737,
		3041,
		2308
	],
	"./NotFound": [
		82044,
		9,
		9810
	],
	"./NotFound.jsx": [
		82044,
		9,
		9810
	],
	"./OcrTask": [
		66774,
		9,
		3602
	],
	"./OcrTask.jsx": [
		66774,
		9,
		3602
	],
	"./PageSpeedInsights": [
		87292,
		9,
		7244
	],
	"./PageSpeedInsights.jsx": [
		87292,
		9,
		7244
	],
	"./PaymentInvoice": [
		19422,
		9,
		8930,
		2273,
		4664,
		1809,
		2931,
		5034,
		2997,
		9612
	],
	"./PaymentInvoice.jsx": [
		19422,
		9,
		8930,
		2273,
		4664,
		1809,
		2931,
		5034,
		2997,
		9612
	],
	"./PaymentMode": [
		78849,
		9,
		4664,
		7953,
		5034,
		2997,
		2938
	],
	"./PaymentMode.jsx": [
		78849,
		9,
		4664,
		7953,
		5034,
		2997,
		2938
	],
	"./PrivateNotes": [
		82945,
		9,
		1667
	],
	"./PrivateNotes.jsx": [
		82945,
		9,
		1667
	],
	"./ProductiveHoursClock": [
		11205,
		9,
		6131
	],
	"./ProductiveHoursClock.jsx": [
		11205,
		9,
		6131
	],
	"./Proposal": [
		90399,
		9,
		2700,
		9080,
		9906,
		13
	],
	"./Proposal.jsx": [
		90399,
		9,
		2700,
		9080,
		9906,
		13
	],
	"./Quote": [
		35387,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		3436,
		5034,
		8197,
		5909
	],
	"./Quote.jsx": [
		35387,
		9,
		8930,
		2273,
		4664,
		691,
		1809,
		2931,
		3436,
		5034,
		8197,
		5909
	],
	"./Recruitment/Recruitment": [
		44964,
		9,
		6500,
		6398
	],
	"./Recruitment/Recruitment.jsx": [
		44964,
		9,
		6500,
		6398
	],
	"./Recruitment/RecruitmentEdit": [
		20016,
		9,
		50
	],
	"./Recruitment/RecruitmentEdit.jsx": [
		20016,
		9,
		50
	],
	"./Recruitment/RecruitmentForm": [
		84490,
		9,
		8308
	],
	"./Recruitment/RecruitmentForm.jsx": [
		84490,
		9,
		8308
	],
	"./Recruitment/RecruitmentInterview": [
		96007,
		9,
		6500,
		5443
	],
	"./Recruitment/RecruitmentInterview.jsx": [
		96007,
		9,
		6500,
		5443
	],
	"./ResetPasswordScreen": [
		34483,
		9
	],
	"./ResetPasswordScreen.jsx": [
		34483,
		9
	],
	"./ReviewAppraisals": [
		92441,
		9,
		8930,
		2273,
		691,
		3651,
		4620,
		9371
	],
	"./ReviewAppraisals.jsx": [
		92441,
		9,
		8930,
		2273,
		691,
		3651,
		4620,
		9371
	],
	"./Role": [
		38858,
		9,
		4664,
		5034,
		2997,
		7451
	],
	"./Role.jsx": [
		38858,
		9,
		4664,
		5034,
		2997,
		7451
	],
	"./RolePage": [
		60715,
		9,
		9646
	],
	"./RolePage.jsx": [
		60715,
		9,
		9646
	],
	"./Salarymanagement": [
		89612,
		9,
		8930,
		2273,
		1238,
		5842,
		1137,
		5363,
		280
	],
	"./Salarymanagement.jsx": [
		89612,
		9,
		8930,
		2273,
		1238,
		5842,
		1137,
		5363,
		280
	],
	"./Settings/GeneralSettings": [
		74364,
		9,
		4664,
		9176
	],
	"./Settings/GeneralSettings.jsx": [
		74364,
		9,
		4664,
		9176
	],
	"./Settings/InvoiceSettings": [
		649,
		9,
		4664,
		5457
	],
	"./Settings/InvoiceSettings.jsx": [
		649,
		9,
		4664,
		5457
	],
	"./Settings/PaymentSettings": [
		99378,
		9,
		8930,
		2273,
		4664,
		334,
		5034,
		2997,
		5410
	],
	"./Settings/PaymentSettings.jsx": [
		99378,
		9,
		8930,
		2273,
		4664,
		334,
		5034,
		2997,
		5410
	],
	"./Settings/Settings": [
		30612,
		9,
		8930,
		2273,
		4664,
		334,
		5034,
		2997,
		8950
	],
	"./Settings/Settings.jsx": [
		30612,
		9,
		8930,
		2273,
		4664,
		334,
		5034,
		2997,
		8950
	],
	"./Settings/components/SelectCurrency": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/currenciesList": [
		52725,
		9,
		7421
	],
	"./Settings/components/SelectCurrency/currenciesList.js": [
		52725,
		9,
		7421
	],
	"./Settings/components/SelectCurrency/index": [
		95376,
		9,
		3083
	],
	"./Settings/components/SelectCurrency/index.jsx": [
		95376,
		9,
		3083
	],
	"./Settings/components/SetingsSection": [
		75576,
		9,
		934
	],
	"./Settings/components/SetingsSection.jsx": [
		75576,
		9,
		934
	],
	"./SignUpEmployee": [
		12568,
		9,
		8930,
		2273,
		9906,
		1065,
		8565,
		2463
	],
	"./SignUpEmployee.jsx": [
		12568,
		9,
		8930,
		2273,
		9906,
		1065,
		8565,
		2463
	],
	"./SuggestionList": [
		96805,
		9,
		1307
	],
	"./SuggestionList.jsx": [
		96805,
		9,
		1307
	],
	"./SuggestionsComplaintForm": [
		22018,
		9,
		275
	],
	"./SuggestionsComplaintForm.jsx": [
		22018,
		9,
		275
	],
	"./TechnicianLogs": [
		34391,
		9,
		3722,
		6056
	],
	"./TechnicianLogs.jsx": [
		34391,
		9,
		3722,
		6056
	],
	"./URL": [
		67954,
		9
	],
	"./URL.css": [
		87017,
		9,
		980
	],
	"./URL.jsx": [
		67954,
		9
	],
	"./UsersList": [
		53681,
		9,
		4113
	],
	"./UsersList.jsx": [
		53681,
		9,
		4113
	],
	"./VoiceOverElevenLabs": [
		81190,
		9,
		8737,
		118
	],
	"./VoiceOverElevenLabs.jsx": [
		81190,
		9,
		8737,
		118
	],
	"./VoiceOvers": [
		14282,
		9,
		6440
	],
	"./VoiceOvers.jsx": [
		14282,
		9,
		6440
	],
	"./logo.png": [
		65562,
		1,
		3172
	],
	"./responsive.css": [
		86202,
		9
	],
	"./style.css": [
		13465,
		9
	],
	"./textDectect-fileUpload": [
		41428,
		9,
		2006
	],
	"./textDectect-fileUpload.jsx": [
		41428,
		9,
		2006
	],
	"./textToSpeech/slectCountory": [
		76164,
		9,
		5716
	],
	"./textToSpeech/slectCountory.jsx": [
		76164,
		9,
		5716
	],
	"./textToSpeech/voices": [
		40916,
		9,
		8737,
		5057
	],
	"./textToSpeech/voices.jsx": [
		40916,
		9,
		8737,
		5057
	],
	"./uploadFileToDetectText.css": [
		35326,
		9,
		4303
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 418;
module.exports = webpackAsyncContext;